import SectionHero from "../sectionHeroHome";
import RunningText from "../runningText";
import SectionSlider from "../slider";
import "../../css/homePage.scss";

const HomePage = (props) => {
  return (
    <>
      <main className="home-page">
        <SectionHero {...props.hero} />
        <RunningText />
        <SectionSlider {...props.gallery} />
      </main>
    </>
  );
};

export default HomePage;
